import $ from "jquery";
// import Uijquery from "jquery-ui-dist/jquery-ui";
// import Ui from "jquery-ui-touch-punch";

export function ScrollingButtons(scroller, button) {
  const $scroller = $(scroller);
  const $buttons = $(button);
  const SCROLL_DISTANCE = 30;
  let interval = null;

  function scroll(currentScroll, dir) {
    if (dir == "forward") {
      $scroller.scrollLeft(currentScroll + SCROLL_DISTANCE);
    }
    if (dir == "back") {
      $scroller.scrollLeft(currentScroll - SCROLL_DISTANCE);
    }
  }

  function handleArrowClick(e) {
    e.preventDefault();
    const dir = $(e.currentTarget).data("dir");
    interval = setInterval(() => {
      const currentScroll = $scroller.scrollLeft();
      scroll(currentScroll, dir);
      clearInterval(interval);
    });
    return;
  }
  function handleMouseup(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    clearInterval(interval);
  }

  if (document.getElementsByClassName("pricing-api__nav").length > 0) {
    var list = document.getElementsByClassName("pricing-api__nav")[0];
    var elements1 = list.getElementsByClassName("js-pricing-nav-arrow")[0];
    var elements2 = list.getElementsByClassName("js-pricing-nav-arrow")[1];

    elements1.addEventListener("touchstart", handleArrowClick, false);
    elements2.addEventListener("touchstart", handleArrowClick, false);
  }
}
